// tslint:disable: indent

import { gtmPushEvent } from '../../../helpers/gtm';

export const prettifyImgUrl = (imgUrl: string): string => {
    return `https://static.wixstatic.com/media/${imgUrl.split('/')[3]}`;
};

export const prettifyRichText = (richText: string): any => {
    return richText
        .replace(/<p class="font_8">/g, '')
        .replace(/<\/p>/g, '')
        .replace(/&amp;/g, '')
        .replace(/&nbsp;/g, '')
        .replace(/\n/g, '')
        .split('<br>');
};

export const addSubjectColors = (subject: string) => {
    if (!!subject) {
        if (subject === 'Tech stack') {
            return { bgColor: '#f4fdfc', barBgColor: '#d7f1ef', barFillColor: '#39aea4' };
        } else if (subject === 'Productivity') {
            return { bgColor: '#fff8f5', barBgColor: '#ffe6e6', barFillColor: '#db3838' };
        } else if (subject === 'Scalability') {
            return { bgColor: '#f5f9ff', barBgColor: '#ffe4d4', barFillColor: '#39aea4' };
        } else if (subject === 'Insights') {
            return { bgColor: '#F9F7FE', barBgColor: '#ffe4d4', barFillColor: '#ffbc89' };
        } else {
            return { bgColor: '#f4fdfc', barBgColor: '#d7f1ef', barFillColor: '#39aea4' };
        }
    } else {
        return { bgColor: '#f4fdfc', barBgColor: '#d7f1ef', barFillColor: '#39aea4' };
    }
};

export const addSubjectColorsNew = (score: number) => {
    if (!!score) {
        if (score <= 8) {
            return { bgColor: '#FFF9F9', barBgColor: '#ffe6e6', barFillColor: '#db3838' };
        } else if (score <= 17) {
            return { bgColor: '#FFF9F5', barBgColor: '#ffe4d4', barFillColor: '#ffbc89' };
        } else {
            return { bgColor: '#f4fdfc', barBgColor: '#d7f1ef', barFillColor: '#39aea4' };
        }
    } else {
        return { bgColor: '#f4fdfc', barBgColor: '#d7f1ef', barFillColor: '#39aea4' };
    }
};

export const cleanInput = (input: string): string => {
    return input.replace(/[<>]/g, '');
};

export const encodeText = (text: string) => {
    return btoa(text);
};

export const collectMktoUtms = () => {
    const url = new URL(document.location.href);
    const params = new URLSearchParams(url.search);
    const mktoUtmObj = {
        last_Form_Conversion_Type: 'Technology Assessment',
        UTM_Campaign__c: params.get('utm_campaign') || '',
        UTM_Content__c: params.get('utm_content') || '',
        UTM_Medium__c: params.get('utm_medium') || '',
        UTM_Source__c: params.get('utm_source') || '',
        UTM_Term__c: params.get('utm_term') || '',
        UTM_Campaign_ID: params.get('utm_campaign_id') || '',
    };

    return mktoUtmObj;
};

export const getMktoCookie = (cookieName: string = '_mkto_trk') => {
    const availableCookies = document.cookie;
    const availableCookiesArr = availableCookies.split(';');
    const isAvailableCookie = availableCookiesArr.some((item) => item.includes(cookieName));
    if (isAvailableCookie) {
        const MktoCoockie = availableCookiesArr.find((cookie) => cookie.includes(cookieName));
        const MktoCoockieValue = MktoCoockie ? MktoCoockie.split('=')[1] : '';
        return MktoCoockieValue;
    } else {
        return undefined;
    }
};

export const updateTaGtmEvent = (trigger: string) => {
	const event = 'tech-assessment-event';
	const category = 'Tech Assessment';
	const action = trigger || '';
	const label = document.location.href;
	gtmPushEvent(event, category, action, label);
};
